import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllMarksBySubTaskGuid = createAsyncThunk(
  "Marks/GetAllMarksBySubTaskGuid",
  async (Id, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Marks/GetAllMarksBySubTaskGuid",
        {
          subTaskId: Id.subTaskId,
          mainTaskId: Id.mainTaskId,
        }
      );

      const data = response.data.result;

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAllMarks = createAsyncThunk(
  "Marks/UpdateAllMarks",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Marks/UpdateAllMarks", param);

      const data = response.data;

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidationMarks = createAsyncThunk(
  "YesNo/ValidationYesNoList",
  async (param, { rejectWithValue }) => {
    try {
      //console.log(yesNoEvaluationUpdateList,"yesNoEvaluationUpdateList");

      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Marks/ValidationMarks", param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.message;
        });

        return arrayValidate; // Return the extracted data
      }

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const MarksManager = createSlice({
  name: "MarksManager",
  initialState: {
    //-------------------Get---------------------
    MarksManager: [],
    loadingMarksManager: false,
    errorMarksManager: null,
    //-------------------Update---------------------
    MarksManagerUpdate: [],
    loadingMarksManagerUpdate: false,
    errorMarksManagerUpdate: null,
    //------------------Validation------------------
    MarksManagerValidation: [],
    loadingMarksManagerValidation: false,
    errorMarksManagerValidation: null,
  },
  reducers: {
    SetMarksManager: (state, action) => {
      state.MarksManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllMarksBySubTaskGuid.pending, (state, action) => {
        state.loadingMarksManager = true;
        state.MarksManager = action.payload;
        state.errorMarksManager = null;
      })
      .addCase(GetAllMarksBySubTaskGuid.fulfilled, (state, action) => {
        state.loadingMarksManager = false;
        state.MarksManager = action.payload;
      })
      .addCase(GetAllMarksBySubTaskGuid.rejected, (state, action) => {
        state.loadingMarksManager = false;
        state.errorMarksManager = action.payload;
      })
      //---------------------update------------------------
      .addCase(UpdateAllMarks.pending, (state, action) => {
        state.loadingMarksManagerUpdate = true;
        state.MarksManagerUpdate = action.payload;
        state.errorMarksManagerUpdate = null;
      })
      .addCase(UpdateAllMarks.fulfilled, (state, action) => {
        state.loadingMarksManagerUpdate = false;
        state.MarksManagerUpdate = action.payload;
      })
      .addCase(UpdateAllMarks.rejected, (state, action) => {
        state.loadingMarksManagerUpdate = false;
        state.errorMarksManagerUpdate = action.payload;
      })
      //--------------------Validation----------------
      .addCase(ValidationMarks.pending, (state, action) => {
        state.loadingMarksManagerValidation = true;
        state.MarksManagerValidation = action.payload;
        state.errorMarksManagerValidation = null;
      })
      .addCase(ValidationMarks.fulfilled, (state, action) => {
        state.loadingMarksManagerValidation = false;
        state.MarksManagerValidation = action.payload;
      })
      .addCase(ValidationMarks.rejected, (state, action) => {
        state.loadingMarksManagerValidation = false;
        state.errorMarksManagerValidation = action.payload;
      });
  },
});

export const { SetMarksManager } = MarksManager.actions;

export default MarksManager.reducer;
